import { render } from "./ClaimResolveModal.vue?vue&type=template&id=4a581360"
import script from "./ClaimResolveModal.vue?vue&type=script&lang=js"
export * from "./ClaimResolveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__